import Vue from 'vue';
import ViewComponents from '@/plugins/ViewDesign';
import {isObject} from '@/utils/func';

const requireComponent = require.context('../components', false, /\.vue$/),
    forEach = (arr, cb) => {
        for (let i = arr.length - 1; i >= 0; i--) cb(arr[i]);
    };

forEach(requireComponent.keys(), fileName => {
    const Component = requireComponent(fileName).default,
        n = Component.name || fileName.slice(2, fileName.length - 4);

    Vue.component(n, Component);
});

forEach(ViewComponents, c => {
    Vue.component(c.name, c);
    switch (true) {
    case c.name === 'Message':
        Vue.prototype.$Message = c;
        break;
    case c.name === 'Modal':
        Vue.prototype.$Modal = c;
    }
});
// 高阶函数覆盖Message组件参数
function replaceMessageMethod(type) {
    return (function (option) {
        let result;
        const data = isObject(option) ? option.content : option ? option.toString() : '';
        const replaceStr = data.replace(new RegExp('<', 'g'), '&lt;');
        if (!isObject(option)) {
            result = replaceStr;
        }else {
            option.content = replaceStr;
            result = option;
        }
        return this.message(type, result);
    });
}

Vue.prototype.$Message.success = replaceMessageMethod.call(Vue.prototype.$Message, 'success');
Vue.prototype.$Message.info = replaceMessageMethod.call(Vue.prototype.$Message, 'info');
Vue.prototype.$Message.error = replaceMessageMethod.call(Vue.prototype.$Message, 'error');
Vue.prototype.$Message.warning = replaceMessageMethod.call(Vue.prototype.$Message, 'warning');
Vue.prototype.$Message.loading = replaceMessageMethod.call(Vue.prototype.$Message, 'loading');
